<template>
    <v-card min-width="21vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title><h2>Find a friend</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 pt-7">
            <v-form v-if="firstStep" v-model="valid">
                <v-autocomplete label="Search friend by username" placeholder="Eg. prayertrader"
                                :items="usersAvailableForSharing" v-model="userChoosed" item-text="username"
                                item-value="id" :rules="userRule" small-chips outlined/>
                <v-btn class="mb-3 mt-n2" @click="goToProfile">See Friend »</v-btn>
            </v-form>
            <v-container v-else-if="secondStep" fluid>
                <v-row class="mt-n5 mb-n2">
                    <v-col cols="8" class="d-flex align-center justify-start text-start">
                        <div>
                            <h3 class="mb-2">{{ friendObject.firstName }} {{ friendObject.lastName }}</h3>
                            <h4>From {{ friendObject.country }}</h4>
                            <p>{{ friendObject.username }}</p>
                        </div>
                    </v-col>
                    <v-col cols="4" class="d-flex align-center justify-end">
                        <div>
                            <p class="mb-1" style="font-size: 14px">Visibility</p>
                            <v-chip color="#FFF75F">{{ capitalize(friendObject.profileStatus) }}</v-chip>
                        </div>
                    </v-col>
                </v-row>
                <v-row class="d-flex align-center justify-center text-center mt-5 mb-1">
                    <v-btn class="mr-3" @click="backToUsers">« Back</v-btn>
                    <v-btn v-if="friendObject.profileStatus === 'PUBLIC'" @click="openJournal">View Journal</v-btn>
                    <v-btn v-else @click="sendRequest">Send Request</v-btn>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import Repository from '../../../repositories/sharing';
    import { mapMutations } from 'vuex';
    export default {
        name: "FindUser",
        data() {
            return {
                firstStep: true,
                secondStep: false,
                usersAvailableForSharing: [],
                userChoosed: '',
                friendObject: null,

                // Rules
                valid: false,
                userRule: [
                    u => !!u || 'Select a user',
                ],
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                Repository.getUsersAvailableForSharing().then((response) => {
                    if(response.status < 400) {
                        this.usersAvailableForSharing = response.data;
                    }
                });
            },
            goToProfile() {
                if (this.valid) {
                    this.friendObject = this.usersAvailableForSharing.find((user) => user.id === this.userChoosed);
                    this.firstStep = false;
                    this.secondStep = true;
                } else
                    alert('Select a user first.')
            },
            backToUsers() {
                this.firstStep = true;
                this.secondStep = false;
            },
            ...mapMutations(['setShare']),
            openJournal() {
                let sharingDetails = {
                    id: this.friendObject.id,
                    username: this.friendObject.username,
                    imageUrl: this.friendObject.imageUrl,
                    firstName: this.friendObject.firstName,
                    lastName: this.friendObject.lastName,
                    country: this.friendObject.country,
                    allowComments: false,
                };
                this.setShare(sharingDetails);
                this.$router.push('/book/shared');
            },
            async sendRequest() {
                let shareRequest = {
                    shareStatus: 'REQUESTED',
                    requestedBy: { id: this.$store.state.user.id },
                    toUser: { id: this.friendObject.id }
                };

                await Repository.createShareRequest(shareRequest).then((response) => {
                    if(response.status < 400) {
                        let newShareRequest = response.data;
                        newShareRequest.toUser.firstName = this.friendObject.firstName;
                        newShareRequest.toUser.login = this.friendObject.username;

                        this.$emit('shareRequestCreated', newShareRequest);
                    }
                });
            },
            capitalize(string) {
                return string[0] + string.slice(1).toLowerCase();
            },
            closeWindow() {
                this.$emit('closeWindow');
            },
        }
    }
</script>

<style scoped>

</style>
